@for (button of buttons(); track button.label) {
    <a
        pulse-button
        class="tertiary btn-icon-only md"
        [routerLink]="button.link"
        [ngbTooltip]="button.label | translate"
        [attr.aria-label]="button.label | translate"
        container="body"
    >
        <fa-icon [icon]="button.icon" [fixedWidth]="true" />
    </a>
}
